import type { TooltipProps } from "@mui/material";
import { Tooltip } from "@mui/material";
import type { FC } from "react";

export const ConditionalTooltip: FC<
  Omit<TooltipProps, "title"> & {
    situations: {
      title: string;
      condition: boolean;
    }[];
  }
> = ({ situations, children, ...props }) => {
  const activeSituation = situations.find((s) => s.condition);
  if (!activeSituation) return children;

  const isDisabled =
    !!children.props &&
    typeof children.props === "object" &&
    "disabled" in children.props &&
    children.props.disabled;

  return (
    <Tooltip {...props} title={activeSituation.title}>
      {isDisabled ? <span>{children}</span> : children}
    </Tooltip>
  );
};
